import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [combineActions(rawActions.getVqaModels.request)](state, action) {
      return true
    },
    [combineActions(rawActions.getVqaModels.success, rawActions.getVqaModels.failed, rawActions.getVqaModels.cancel)](
      state,
      action
    ) {
      return false
    },
    [rawActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
